/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_NavInputs */

const en_mk_tb_nav = /** @type {(inputs: Mk_Tb_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build with your team`)
};

const id_mk_tb_nav = /** @type {(inputs: Mk_Tb_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build bersama tim`)
};

/**
* | output |
* | --- |
* | "Build with your team" |
*
* @param {Mk_Tb_NavInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_nav = /** @type {((inputs?: Mk_Tb_NavInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_NavInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_nav(inputs)
	return en_mk_tb_nav(inputs)
});